/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const foodRelationship = useStore((state) => state.foodRelationship);
  const setFoodRelationship = useStore((state) => state.setFoodRelationship);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.foodRelationship.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={foodRelationship}
          onChange={(value) => {
            setFoodRelationship(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'food-relationship',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'A source of pleasure'}>
            <span>🍰</span> {t('onboarding.foodRelationship.options.pleasureSource')}
          </Option>
          <Option value={"A source of stress — I can't always control myself"}>
            <span>😣</span> {t('onboarding.foodRelationship.options.stressSource')}
          </Option>
          <Option value={'Just fuel for my body'}>
            <span>⚡</span> {t('onboarding.foodRelationship.options.bodyFuel')}
          </Option>
          <Option value={'A way to take care of myself'}>
            <span>💚</span> {t('onboarding.foodRelationship.options.selfCare')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
